import { render, staticRenderFns } from "./configItems.vue?vue&type=template&id=02d4efd2&scoped=true"
import script from "./configItems.vue?vue&type=script&lang=js"
export * from "./configItems.vue?vue&type=script&lang=js"
import style0 from "./configItems.vue?vue&type=style&index=0&id=02d4efd2&prod&lang=less&scoped=true"
import style1 from "./configItems.vue?vue&type=style&index=1&id=02d4efd2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d4efd2",
  null
  
)

export default component.exports